import { EnvironmentType } from "../utils/settings";

export interface IAuthSettings {
    authUrl: string;
    clientId: string;
    clientSecret: string;
    responseType: string;
    scope: string;
    checkSessionIntervalInSeconds: number;
    sessionTimeoutIntervalInMilliseconds: number;
    captchaKey?: string;
    captchaSecret?: string;
}

const localSetting: IAuthSettings = {
   authUrl: "https://localhost",
    //authUrl: "https://gateway2.vinformatix.com:1203/platform/svc",
    clientId: "community-connect",
    clientSecret: "901564A5-E7FE-42CB-B10D-61EF6A8F3654",
    responseType: "code",
    scope: "openid profile email roles phone",
    checkSessionIntervalInSeconds: 1800,
    sessionTimeoutIntervalInMilliseconds: 3600000,
    captchaKey: "6LeUuusqAAAAAMfpJs6C07Kvm5xumimsDKh23G5a",
};

const devSetting: IAuthSettings = {
    authUrl: "https://template.dev.vfx.local/svc",
    clientId: "community-connect",
    clientSecret: "901564A5-E7FE-42CB-B10D-61EF6A8F3654",
    responseType: "code",
    scope: "openid profile email phone roles",
    checkSessionIntervalInSeconds: 3600,
    sessionTimeoutIntervalInMilliseconds: 3600000,
    captchaKey: "6LeUuusqAAAAAMfpJs6C07Kvm5xumimsDKh23G5a",
};

const qaSetting: IAuthSettings = {
    authUrl: "https://here-now-qa.vinformatix.com/svc",
    clientId: "community-connect",
    clientSecret: "901564A5-E7FE-42CB-B10D-61EF6A8F3654",
    responseType: "code",
    scope: "openid profile email phone roles",
    checkSessionIntervalInSeconds: 3600,
    sessionTimeoutIntervalInMilliseconds: 3600000,
    captchaKey: "6LeUuusqAAAAAMfpJs6C07Kvm5xumimsDKh23G5a",
};

const sandboxSetting: IAuthSettings = {
    authUrl: "https://here-now-sandbox.vinformatix.com/svc",
    clientId: "community-connect",
    clientSecret: "901564A5-E7FE-42CB-B10D-61EF6A8F3654",
    responseType: "code",
    scope: "openid profile email phone roles",
    checkSessionIntervalInSeconds: 3600,
    sessionTimeoutIntervalInMilliseconds: 3600000,
    captchaKey: "6LeUuusqAAAAAMfpJs6C07Kvm5xumimsDKh23G5a",
};

const stagingSetting: IAuthSettings = {
    authUrl: "https://here-now-staging.vinformatix.com/svc",
    clientId: "community-connect",
    clientSecret: "901564A5-E7FE-42CB-B10D-61EF6A8F3654",
    responseType: "code",
    scope: "openid profile email phone roles",
    checkSessionIntervalInSeconds: 3600,
    sessionTimeoutIntervalInMilliseconds: 3600000,
    captchaKey: "6LeUuusqAAAAAMfpJs6C07Kvm5xumimsDKh23G5a",
};

const demoSetting: IAuthSettings = {
    authUrl: "https://here-now-demo.vinformatix.com/svc",
    clientId: "community-connect",
    clientSecret: "901564A5-E7FE-42CB-B10D-61EF6A8F3654",
    responseType: "code",
    scope: "openid profile email phone roles",
    checkSessionIntervalInSeconds: 3600,
    sessionTimeoutIntervalInMilliseconds: 3600000,
    captchaKey: "6LeUuusqAAAAAMfpJs6C07Kvm5xumimsDKh23G5a",
};

const prodSetting: IAuthSettings = {
    authUrl: "https://here-now.vinformatix.com/api",
    clientId: "community-connect",
    clientSecret: "901564A5-E7FE-42CB-B10D-61EF6A8F3654",
    responseType: "code",
    scope: "openid profile email phone roles",
    checkSessionIntervalInSeconds: 3600,
    sessionTimeoutIntervalInMilliseconds: 3600000,
    captchaKey: "6LeUuusqAAAAAMfpJs6C07Kvm5xumimsDKh23G5a",
};

export const GetAuthSetting = (environment: EnvironmentType): IAuthSettings => {
    switch (environment) {
        case EnvironmentType.local: {
            return localSetting;
        }
        case EnvironmentType.dev: {
            return devSetting;
        }
        case EnvironmentType.qa: {
            return qaSetting;
        }
        case EnvironmentType.sandbox: {
            return sandboxSetting;
        }
        case EnvironmentType.staging: {
            return stagingSetting;
        }
        case EnvironmentType.demo: {
            return demoSetting;
        }
        case EnvironmentType.prod: {
            return prodSetting;
        }
    }
}